import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import getTheme from "./Theme"; // Custom theme file
import RoutesComponent from "./routes/Routes"; // Ensure this file has the correct routes
import { SettingsProvider } from "./context/SettingsContext";

import { useSettings } from "./context/SettingsContext";

const AppContent = () => {
  const { theme, accent } = useSettings();
  const muiTheme = getTheme(theme, accent);
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <RoutesComponent />
    </ThemeProvider>
  );
};

const App = () => {
  return (
    <SettingsProvider>
      <AppContent />
    </SettingsProvider>
  );
};

export default App;
